import {
	PRIVATE_FREEFORM_API_KEY_ENV,
	PRIVATE_FREEFORM_API_VERSION_ENV,
	PUBLIC_API_URL_ENV,
} from 'tools/environments';

import { GetSectionByCategoryResponse } from './types';

export const getSectionsByCategory = async (
	categoryId: number
): Promise<GetSectionByCategoryResponse> => {
	const apiUrl = `${PUBLIC_API_URL_ENV}/helpcentre/sectionsbycategory?categoryId=${categoryId}`;

	const response: GetSectionByCategoryResponse = await fetch(apiUrl, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Ocp-Apim-Subscription-Key': `${PRIVATE_FREEFORM_API_KEY_ENV}`,
			'Api-Version': `${PRIVATE_FREEFORM_API_VERSION_ENV}`,
		},
	})
		.then((res) => res.json())
		.catch((error) => {
			console.error('Error fetching sections by category:', error);
			return [];
		});

	return response;
};
